class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    //MVアニメーション
    const mvAnimation = () => {
      let tl = gsap.timeline({repeat: 0, repeatDelay: 1});
      const mvImg = document.querySelectorAll(".js-mv__fade").length / 3 - 1

      for (let index = 0; index < mvImg; index++) {
        const num = index + 1
        tl.fromTo(`.js-mv-${num}`, 0.4,
          {
            autoAlpha: 0,

          }, {
            autoAlpha: 1,

          },
          "-=0.1"
        );
      }
      gsap.to(".js-top__fixedBnr", { autoAlpha: 1, duration: 0.3 , delay:3});
    }

    const mvTextAnimation = () => {
      let tl = gsap.timeline({repeat: 0, repeatDelay: 1});

      tl.add(textAnimation01, 1.5,);
      tl.add(textAnimation02, 1.5);
      tl.add(textAnimation01SP, 1.5);
      tl.add(textAnimation02SP, 1.5);
      tl.to(".js-mv-last ",1,{
        autoAlpha: 1,
      },
      "+=1.4")


    }



    setTimeout(mvAnimation,1200)
    setTimeout(mvTextAnimation,1000)

    function textAnimation01 () {

      const text01 = document.querySelector(".js-strip-01")

      text01.classList.add("is-show")
    }

    function textAnimation02 () {
    setTimeout(() => {
        const text02 = document.querySelector(".js-strip-02")
        text02.classList.add("is-show")
      }, 200);
    }

    function textAnimation01SP () {

      const text01 = document.querySelector(".js-strip-01-sp")

      text01.classList.add("is-show")
    }

    function textAnimation02SP () {
    setTimeout(() => {
        const text02 = document.querySelector(".js-strip-02-sp")
        text02.classList.add("is-show")
      }, 200);
    }

    //固定バナーの表示制御
    const fixedBnr = document.querySelector(".js-top__fixedBnr")
    const bodyHeight = document.querySelector(".l-main").clientHeight;
    const footerHeight = document.querySelector(".l-footer").clientHeight;

    if (window.matchMedia('(max-width: 768px)').matches) {
      scrollFade(1800)
    }else{
      scrollFade(2500)
    }

    function  scrollFade (num) {

      window.addEventListener('scroll', (event) => {
        let scroll_y = window.scrollY;

        if(scroll_y > bodyHeight -  footerHeight - num){
          fixedBnr.classList.add("is-fade")
        }else{
          fixedBnr.classList.remove("is-fade")
        }

      });
      // window.addEventListener('resize', (event) => {
      //   location.reload();
      // });
    }

    // 施工事例　スライダー
    $(function(){
      $('.s-top-case').slick({
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>',
        autoplay: true,
        adaptiveHeight: true,
        centerMode: true,
        centerPadding: "10%",
        dots: false,
        variableWidth: true,
        pauseOnFocus: false,
        pauseOnHover: false,
      });
    });

    // MVテキスト分割
      const texts = document.querySelectorAll('.text-sprit');

      texts.forEach((text) => {
        let html = '';
        const strs = text.textContent.split('');

        strs.forEach((str) => {
          const replacedStr = str.replace(/\s|&nbsp;/g, '&nbsp;');
          html += `<span>${replacedStr}</span>`;
        });
        text.innerHTML = html;
      });



    // ブレイクポイントを過ぎたらローディング
    const breakpoint = window.matchMedia("(max-width:768px)");

    breakpoint.addEventListener("change", () => {
      window.location.reload();
    });

  }
}